import React, { useEffect, useState } from "react";
import { getOurStory } from "../api/companyService";
import { sleep } from "../utils/sleep";

const OurStory = () => {
  const [ourStory, setOurStory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
      useEffect(() => {
      const fetchOurStory = async () => {
        try {
          // simulate network delay (3 sec)
          //await sleep(3000);
  
          const data = await getOurStory(); // asynchronous call
          setOurStory(data);
        } catch (err) {
          setError("Failed to load our story.");
        } finally {
          setLoading(false);
        }
      };
  
      fetchOurStory();
      }, []);
    
    // Loading Overlay
    if (loading) {
      return (
        <div className="loading-overlay d-flex align-items-center justify-content-center py-5">
          <div className="spinner-border text-primary" role="status"></div>
          <span className="ms-3 fw-semibold">Loading our story...</span>
        </div>
      );
    }
    
     // Error Message
    if (error) {
      return (
        <div className="error-container d-flex flex-column align-items-center justify-content-center py-5">
          <p className="text-danger fs-7">{error}</p>
          <button
            className="btn btn-outline-primary mt-3"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      );
  }
  
  return (
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <img
                src={require(`../assets/images/others/${ourStory.image}`)}
                alt={ourStory.title}
                height="80%"
                width="80%"
                // className="img-fluid rounded shadow-lg"
              />
            </div>
            <div className="col-lg-6">
                <h2 className="fw-bold mb-3">{ourStory.title}</h2>
                {ourStory.paragraphs.map((para, idx) => (
                  <p className="text-muted" key={idx}>
                    {para}
                  </p>
                ))}
            </div>
          </div>
        </div>
      </section>
  );
};

export default OurStory;
